module.exports = __webpack_public_path__ + "img/symbol_5.676e94dc.png";